import React from "react";
import { connect } from 'react-redux';
import { Card, CardHeader, CardFooter, CardBody, Container, Row, Col, } from "reactstrap";

import UserHeader from 'components/Headers/UserHeader.js';


const Profile = (props) => {

    const fetchData = React.useCallback(() => {
        // console.log('fetching')
    }, [])
    React.useEffect(() => {
        fetchData()
        document.title = "Add Event - Depact"
    }, [fetchData])

    return (
        <>
            <UserHeader id={props.username} />
            {/* Page content */}
            <Container className="mt--7" fluid>
                <Row>
                    <Col className="order-xl-1" xl="12">
                        <Card className={"shadow cardbg-" + props.theme}>
                            <CardHeader className={"cardbg-" + props.theme}>
                                <Row className="align-items-center">
                                    <Col xs="8">
                                        <h3 className={"mb-0 textb-" + props.theme}>About</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody className="pb-0">
                                <div>
                                    <h4 className="no-w">This Application is created for the purpose of managing events for teachers and students.</h4>
                                    <p></p>
                                </div>

                            </CardBody>
                            <CardFooter className={"border-0 cardbg-" + props.theme}>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};


export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Profile);
